import capitalize from 'lodash-es/capitalize';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useQuery } from '@apollo/client';
import { LeagueStageEnum } from '../../../shared/league-status-enum';
import { DailyProgramTypes } from '../../../shared/program-type-enum';
import { dashSpaceSwap } from '../../../utils/url-search-helpers';
import { LEAGUE_BASICS_QUERY } from './HOMEPAGE_QUERIES';
import { Button, Loading, Error } from '../../../components';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

const UpcomingEvents = ({ cityName, chosenSport }) => {
  const {
    data: leagueListData,
    loading: leagueListLoading,
    error: leagueListError,
  } = useQuery(LEAGUE_BASICS_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      input: {
        cityName,
        sport: chosenSport,
        stage: LeagueStageEnum.UPCOMING,
        omitReoccuringParents: false,
        pagination: {
          numPerPage: 3,
          pageNum: 1,
        },
        discoverable: true,
        omitArchived: true,
      },
    },
  });

  const { leagueList } = leagueListData || {};
  const { leagues } = leagueList || {};

  if (leagueListLoading) {
    return <Loading type="inline" />;
  }
  if (leagueListError) {
    return <Error error={leagueListError} />;
  }

  if (leagueListData?.leagueList?.leagues?.length < 1) {
    return (
      <div className={cx('titleHeader', 'mb-0')}>
        <div className="container">
          <Link
            to={{
              pathname: '/discover',
              search: `?cityName=${dashSpaceSwap(cityName, 'toSpace')}&sportNames[]=${dashSpaceSwap(
                chosenSport,
                'toSpace'
              )}`,
            }}
          >
            <Button className={cx('ctaButton')}>See All Upcoming Events!</Button>
          </Link>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className={cx('upcomingEvents', 'container')}>
        <h1 className={cx('fancyText')}>
          {' '}
          Upcoming {chosenSport && capitalize(chosenSport)} Events in {cityName}{' '}
        </h1>
        <div className="row">
          {leagues.map(({ _id, name, details: { description = '' }, start_date, programType }) => (
            <div className="col-12 col-md-4 mb-2" key={_id}>
              <div className={cx('eventCard')}>
                <div className={cx('leftDate')}>
                  <div className={cx('day')}>
                    {moment(start_date).format('dddd')} <br />
                  </div>
                  <div className={cx('date')}>
                    {moment(start_date).format('MMM')} <br />
                    {moment(start_date).format('DD')}
                  </div>
                </div>
                <div className={cx('rightDetails')}>
                  <div className={cx('event')}>{name}</div>
                  <div className={cx('subtitle')}>
                    {moment(start_date).format('dddd, MMMM DD YYYY')}
                  </div>
                  <div
                    className={cx('description')}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html:
                        description.length > 80
                          ? `${description.substring(0, 79)}...`
                          : description,
                    }}
                  />
                  <Link to={DailyProgramTypes.includes(programType) ? `/d/${_id}` : `/l/${_id}`}>
                    <Button>Register</Button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {chosenSport ? (
        <div className={cx('titleHeader', 'mt-5', 'mb-0')}>
          <div className="container">
            <Link
              to={{
                pathname: '/discover',
                search: `?cityName=${dashSpaceSwap(
                  cityName,
                  'toSpace'
                )}&sportNames[]=${dashSpaceSwap(chosenSport, 'toSpace')}`,
              }}
            >
              <Button className={cx('ctaButton')}>See All Upcoming Events!</Button>
            </Link>
          </div>
        </div>
      ) : (
        <div className={cx('upcomingEvents', 'container')}>
          <Link
            to={{
              pathname: '/discover',
              search: `?cityName=${dashSpaceSwap(cityName, 'toDash')}`,
            }}
          >
            <Button className={cx('blueButton')}>See All</Button>
          </Link>
        </div>
      )}
    </>
  );
};

UpcomingEvents.propTypes = {
  cityName: PropTypes.string,
  chosenSport: PropTypes.string,
};

UpcomingEvents.defaultProps = {
  cityName: '',
  chosenSport: null,
};

export default UpcomingEvents;
